module.exports = "/_next/static/images/PersonalizeOnEveryChannelMobile@2x-397f589587324ee78510d739290fae02.png";